// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CartCollectionResult, getCarts, GetCartsApiParameter } from "@insite/client-framework/Services/CartService";

type GetCartsParameter = {
    apiParameter: GetCartsApiParameter;
} & HasOnSuccess &
    HasOnError<string>;

type HandlerType = ApiHandlerDiscreteParameter<GetCartsParameter, GetCartsApiParameter, CartCollectionResult>;

export const DispatchBeginLoadSavedCarts: HandlerType = props => {
    props.dispatch({
        type: "xRecentSavedCarts/SetLoading",
        parameter: { loading: true },
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter.apiParameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    const apiResult = await getCarts(props.apiParameter);
    if (apiResult.successful) {
        props.apiResult = apiResult.result;
    } else {
        props.parameter.onError?.(apiResult.errorMessage);
    }
};

export const DispatchCompleteLoadSavedCarts: HandlerType = props => {
    props.dispatch({
        type: "xRecentSavedCarts/SetData",
        data: props.apiResult,
    } as any);
};

export const chain = [
    DispatchBeginLoadSavedCarts,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadSavedCarts,
];

const loadRecentSavedCarts = createHandlerChainRunner(chain, "loadRecentSavedCarts");
export default loadRecentSavedCarts;
